import React from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import { FormatDateTime } from "../../../../../../utils/functions/ResourceFunctions";
import {
  useApproveDeclineObjectiveMutation,
  useGetSingleAppraisalObjectiveQuery
} from "../../../../../api/hrApi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../../global/components/Buttons/buttons";
import { FormTemplate } from "../../../../Components/Forms/InputTemplate";
import PageLayout from "../../../../Components/Layout/PageLayout";
import { getStatusText } from "../../../Finance/CostCenter/Class";
import ApproveModal from "../Modals/ApproveModal";
import { AppraisalDeclineModal } from "../Modals/DeclineModal";

export const ViewAppraisalObjective = () => {
  const { id } = useParams();
  const { data } = useGetSingleAppraisalObjectiveQuery(id);
  const navigation = useNavigate();
  const [approveDecline, { isLoading }] = useApproveDeclineObjectiveMutation();
  const [openApproveModal, setOpenApproveModal] = React.useState(false);
  const [openDeclineModal, setOpenDeclineModal] = React.useState(false);

  const [comment, setComment] = React.useState("");
  const declineVariable = 1;
  const approveVaiable = 0;
  const handleComment = (e) => {
    setComment(e.target.value);
  };
  const declineAction = async (type) => {
    if (!comment && type === 7) {
      toast.error("Please enter a comment");
      return;
    }
    try {
      const response = await approveDecline({
        objectiveIds: [parseInt(id)],
        comment,
        approvalType: type,
      }).unwrap();
      if (response?.successful) {
        setOpenDeclineModal(false);
        setOpenApproveModal(false);
        toast.success(response?.statusMessage);
        navigation("/dashboard/hr/HR-Appraisal-Setup/Manage-Objectives");
      }
    } catch (error) {
      toast.error(
        error?.data?.statusMessage ?? "Error approving Appraisal Objectives"
      );
    }
  };

  const handleApproveModal = () => setOpenApproveModal(!openApproveModal);
  const handleDeclineModal = () => setOpenDeclineModal(!openDeclineModal);
  const months = [
    { label: "January" },
    { label: "February" },
    { label: "March" },
    { label: "April" },
    { label: "May" },
    { label: "June" },
    { label: "July" },
    { label: "August" },
    { label: "September" },
    { label: "October" },
    { label: "November" },
    { label: "December" },
  ];
  return (
    <PageLayout title={"Appraisal Objectives Details"} hasBack={true}>

      <FormProvider>

        <FormTemplate className={DashboardStyle.view_app_components}>
          <section
            style={{
              backgroundColor: "#F8FBF8",
              border: "1px solid #D9E9DA",
              borderRadius: "8px",
            }}
            className={DashboardStyle.form_section}
          >
            <h4 className={DashboardStyle.form_section_title}>
              Process <br /> Information
            </h4>
            <div className={DashboardStyle.labels_group}>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(32.3%, 1fr))",
                  gap: "10px",
                }}
              >
                <div>
                  <p>Title:</p>
                  <h4>{data?.responseObject?.title}</h4>
                </div>
                <div>
                  <p>Year:</p>
                  <h4>{data?.responseObject?.year}</h4>
                </div>
                <div>
                  <p>Description:</p>
                  <h4>{data?.responseObject?.description}</h4>
                </div>
                <div>
                  <p>Weight (%):</p>
                  <h4>{data?.responseObject?.weight}%</h4>
                </div>
                <div>
                  <p>Objective Type:</p>
                  <h4>{data?.responseObject?.objectiveType}</h4>
                </div>
                <div>
                  <p>Department:</p>
                  <h4>{data?.responseObject?.departmentName}</h4>
                </div>
                <div>
                  <p>Appraisal Period:</p>
                  <h4>
                    Start Month{" "}
                    {
                      months[
                        data?.responseObject?.appraisalPeriod?.startMonth ?? 0
                      ]?.label
                    }
                    {"; "}
                    End Month{" "}
                    {
                      months[
                        data?.responseObject?.appraisalPeriod?.endMonth ?? 0
                      ]?.label
                    }
                    {"; "}
                    Year {data?.responseObject?.appraisalPeriod?.year}
                  </h4>
                </div>
                <div>
                  <p>Approval Status:</p>
                  <h4>
                    {typeof data?.responseObject?.approvalStatus === "number"
                      ? getStatusText(data?.responseObject?.approvalStatus)
                      : data?.responseObject?.approvalStatus}
                  </h4>
                </div>
                <div>
                  <p>Created Date:</p>
                  <h4>
                    {FormatDateTime(
                      data?.responseObject?.createdDate,
                      "DD/MM/YYYY"
                    )}
                  </h4>
                </div>
                <div>
                  <p>Job Role:</p>
                  <div>
                    <h4>
                      {" "}
                      {data?.responseObject?.designation?.designationName}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {data?.responseObject?.approvalStatus !== 0 && (
            <div className={DashboardStyle.button_cage}>
              <button
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
                onClick={handleApproveModal}
                type="button"
              >
                Approve
              </button>
              <ActionButtons
                width={"auto"}
                className={DashboardStyle?.button_cage_weight}
                style={{ backgroundColor: "red" }}
                onClick={handleDeclineModal}
                type="button"
              >
                Decline
              </ActionButtons>
            </div>
          )}
        </FormTemplate>
      </FormProvider>

      {openDeclineModal && (
        <AppraisalDeclineModal
          openModal={openDeclineModal}
          closeModal={handleDeclineModal}
          handleComment={handleComment}
          handleDelete={() => declineAction(declineVariable)}
          isLoading={isLoading}
          disabled={!comment}
        />
      )}
      <ApproveModal
        isOpen={openApproveModal}
        handleClose={handleApproveModal}
        handleDelete={() => declineAction(approveVaiable)}
        handleComment={handleComment}
        isLoading={isLoading}
        headText={"Approve Appraisal Objective"}
      />
    </PageLayout>
  );
};
